// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "textarea[data-v-66df57be]{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#f6f8fa;border:1px solid #bababa;border-radius:.2rem;max-height:18rem;min-width:10rem;overflow-y:hidden;padding:.5rem;resize:vertical}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
